import { useMutation } from "react-query";
import actionService from "../../services/actionService";

const useUploadActionAttachments = () =>
  useMutation(actionService.uploadAttachments);

export default useUploadActionAttachments;
